export default __webpack_public_path__ + "static/media/thor-hammer.7bece14e.svg";